export const messages = {
  configurationChanged: 'configuration-changed',
  sessionSaved: "session-saved",
  sessionSavedSuccess: "session-saved-success",
  sessionSavedError: "session-saved-error",
};
